import { useQuery } from '@tanstack/react-query';
import type { LegalDocKey, LegalLang } from './legalDocs';

export interface LegalDoc {
  title: string;
  body: string;
}

export interface LegalContent {
  docTitles: Record<LegalDocKey, string>;
  convenience_notice: string;
  'privacy-policy': LegalDoc;
  'terms-and-conditions': LegalDoc;
  'terms-service': LegalDoc;
}

/**
 * Loads the legal content for a language from /legal/{lang}.json. Self-contained
 * (NOT part of the booking app's i18n namespaces) — legal docs are content, have
 * their own language set incl. Italian, and live on a separate host. Cached
 * forever (static legal text).
 */
export function useLegalContent(lang: LegalLang) {
  return useQuery({
    queryKey: ['legal-content', lang],
    queryFn: async (): Promise<LegalContent> => {
      const res = await fetch(`/legal/${lang}.json`);
      if (!res.ok) throw new Error(`legal content ${lang}: ${res.status}`);
      return res.json();
    },
    staleTime: Infinity,
  });
}
